import React from 'react';
import '../../css/legal.css';

const DEFAULT_TEXT =
    'TamCare lưu trữ/hiển thị thông tin bạn nhập; trợ lý AI chỉ gợi ý tham khảo, không chẩn đoán hay điều trị. ' +
    'Không thay ý kiến bác sĩ. Nguy hiểm: gọi 115 hoặc đến cơ sở y tế.';

const AiDisclaimerBanner = ({ text = DEFAULT_TEXT }) => (
    <div className="tamcare-ai-disclaimer-banner" role="note">
        <strong>⚠️ Lưu ý:</strong> {text}
    </div>
);

export default AiDisclaimerBanner;
